import JoinExistingSettings from './JoinExistingSettings';

export default JoinExistingSettings;
